// src/components/Header.jsx

import React from 'react';
import { Navbar, Container, Form, FormControl, Button, Nav, InputGroup } from 'react-bootstrap';

export default function Header() {
  return (
    <Navbar bg="white" expand="lg" className="shadow-sm">
      <Container>
        <Navbar.Brand href="#home" className="fw-bold text-primary fs-4">
          Office<span className="text-secondary">Supplies</span>ME
        </Navbar.Brand>
        <span className="text-muted d-none d-sm-inline me-4">IT & Office Solutions for Businesses</span>
        
        {/* Search Bar */}
        <div className="flex-grow-1 mx-lg-4 d-none d-md-block">
          <InputGroup>
            <FormControl 
              placeholder="Search products, brands or categories" 
              aria-label="Search" 
            />
          </InputGroup>
        </div>

        {/* Buttons and Cart */}
        <Nav className="ms-auto">
          <Button variant="link" className="text-decoration-none text-muted d-none d-sm-inline">Login</Button>
          <Button variant="link" className="text-decoration-none text-muted d-none d-sm-inline">Corporate</Button>
          <div className="ms-3 ps-3 border-start">
            <Button variant="link" className="text-decoration-none text-dark">
              🛒 <span className="ms-1">Cart</span>
            </Button>
          </div>
        </Nav>
      </Container>
    </Navbar>
  );
}